import { Task } from '@redux-saga/types';
import { cancel, fork, select, take } from 'redux-saga/effects';
import { TOKENS_REFRESH, TOKENS_REMOVE } from '../actions/app';
import { isAuthenticated as isAuthenticatedSelector } from '../selectors/app';

export interface Action<Props> {
  payload: Props;
}

export function tracked<Props = {}>(
  worker: (...args: any[]) => any,
  ACTIVATE: string | string[],
  DEACTIVATE: string | string[]
) {
  return function* (params?: any) {
    while (true) {
      const activateAction: Action<Props> = yield take(ACTIVATE);
      const task: Task = yield fork(worker, activateAction, params);
      yield take(DEACTIVATE);
      yield cancel(task);
    }
  };
}

export function personal(worker: (...args: any[]) => any) {
  return function* (params?: any) {
    while (true) {
      const { isAuthenticated }: ReturnType<typeof isAuthenticatedSelector> = yield select(
        isAuthenticatedSelector
      );
      if (!isAuthenticated) {
        yield take(TOKENS_REFRESH);
      }

      const task: Task = yield fork(worker, params);
      yield take(TOKENS_REMOVE);
      yield cancel(task);
    }
  };
}
